import { ArrowLeft } from 'lucide-react'

import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'
import { useBackNavigation } from '@/hooks/use-back-navigation'
import { cn } from '@/lib/cn'

interface BackButtonProps {
  label?: string
  className?: string
}

export function BackButton({ label = 'Voltar', className }: BackButtonProps): ReactElement {
  const goBack = useBackNavigation()

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={goBack}
      className={cn('-ml-2 h-11', className)}
    >
      <ArrowLeft aria-hidden />
      {label}
    </Button>
  )
}
